"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arraysBothTrue = exports.arraysAreEqual = void 0;
var errMsg = "CommonLib: arraysAreEqual: 'item' had no 'isEqual' function!"; // given 2 arrays, will check that every item of each array match
// according to the isEqual function of the first array's item

var arraysAreEqual = function arraysAreEqual(array1, array2) {
  // if only one or other is undefined or null, FALSE
  if (array1 === undefined && array2 !== undefined || array1 !== undefined && array2 === undefined || array1 === null && array2 !== null || array1 !== null && array2 === null) return false; // both are null or undefined, TRUE

  if (array1 === null && array2 === null || array1 === undefined && array2 === undefined) return true; // if only one is empty, FALSE

  if ((array1 === null || array1 === void 0 ? void 0 : array1.length) === 0 && (array2 === null || array2 === void 0 ? void 0 : array2.length) !== 0 || (array1 === null || array1 === void 0 ? void 0 : array1.length) !== 0 && (array2 === null || array2 === void 0 ? void 0 : array2.length) === 0) return false; // otherwise iterate through entire list and confirm each item equal

  if (array1 && array2) {
    return array1.every(function (item, index) {
      var equality = item === array2[index];
      return equality;
    });
  } // if you get this far, assume FALSE


  return false;
}; // given 2 arrays, will check that every item of each array match
// according to the given boolean function


exports.arraysAreEqual = arraysAreEqual;

var arraysBothTrue = function arraysBothTrue(array1, array2, truthFunction) {
  // if only one or other is empty...
  if (!array1 != !array2) return false; // if both are null or empty...

  if (!array1 && !array2 || array1.length === 0 && array2.length === 0) return true;
  return array1.every(function (item, index) {
    try {
      var equality = truthFunction(item, array2[index]);
      return equality;
    } catch (err) {
      console.error(errMsg, err);
      return false;
    }
  });
};

exports.arraysBothTrue = arraysBothTrue;